export default "__VITE_ASSET__q5nn9tro__"